// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3F8J7","rootSuccess":"CompleteLink_rootSuccess__3CLdt","rootFailure":"CompleteLink_rootFailure__1p2Zd","isDisabled":"CompleteLink_isDisabled__3EJaL"};